import {connect} from 'react-redux';
import Search from './Search.jsx';
import {
  setSearchValueInState,
  setSearchBySelected
} from './actionTypes';
import { 
  handleSearchEnterKeyPress,
  handleSearch
} from './actions'; 

const mapStateToProps = state => ({
  searchByOptions: state.admin.home.searchByOptions,
  selectedOption: state.admin.home.searchByOptions.find(o => o.selected),
  searchValue: state.admin.home.searchValue
});

const mapDispatchToProps = dispatch => ({
  onSearchByOptionClick: id => dispatch(setSearchBySelected(id)),
  onSearchEnterKeyPress: event => dispatch(handleSearchEnterKeyPress(event)),
  onSearchClick: () => dispatch(handleSearch()),
  onSearchValueChange: searchValue => dispatch(setSearchValueInState(searchValue))
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);



// WEBPACK FOOTER //
// ./src/features/admin/home/SearchContainer.jsx